import { useEffect } from "react";
import { getCorporateServiceOptionsThunk } from "../store/events/eventThunk";
import { useAppDispatch, useAppSelector } from "./storeHooks";

const useCorporateServiceOptions = () => {
	const dispatch = useAppDispatch();
	const { corporateServiceOptions, corporateServiceOptionsStatus } = useAppSelector((state) => state.events);

	useEffect(() => {
		if (corporateServiceOptionsStatus === "idle") dispatch(getCorporateServiceOptionsThunk());
	}, [corporateServiceOptionsStatus, dispatch]);

	return corporateServiceOptions;
};

export default useCorporateServiceOptions;
